<script setup lang="ts">
import { CommonResultId } from '@collector/sportsapi-client-legacy'
import { useParticipantResult } from '@desktop/views/Relation/composables'

const { getHomeParticipantResult, getAwayParticipantResult } =
  useParticipantResult()
</script>

<template>
  <div class="text-center text-2xl font-bold text-nowrap select-none">
    {{ getHomeParticipantResult(CommonResultId.Result) }} :
    {{ getAwayParticipantResult(CommonResultId.Result) }}
  </div>
</template>
